module.exports = __webpack_public_path__ + "img/5.9eb4b09c.png";